import styled from 'styled-components';

const BuildingImage = styled.div`
  background-color: #fafafa;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  z-index: 0;
  width: 20vw;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
`;

const BuildingAddress = styled.p`
  color: rgb(74,74,74);
`;

const BuildingName = styled.strong`
	font-size: 23px;
	font-weight: 400;
	word-break: break-word;

  margin: 0 0 0.25em;
  display: block;
  color: ${ props => props.theme.heading };
`;

const BuildingDetail = styled.div`
	margin: 0 0 1em;

	@media (max-width: 1200px) {
		margin: 0;
	}

  label {
		font-weight: bold;
		font-size: 12px;
		text-transform: uppercase;
		letter-spacing: 1px;

    margin: 0 0 0.25em;
    display: block;
  }
`;

const BuildingDetailsContainer = styled.div`
	margin: 2em 0 0 0;
	display: flex;
	flex-direction: column;

	@media (max-width: 1200px) {
		flex-direction: row;
		justify-content: space-between;
	}
`;

const BuildingInfo = styled.div`
	position: relative;

	padding: 20px;
	width: 25vw;

	@media (max-width: 1200px) {
		width: 70vw;
	}
`;

const ListInfoContainer = styled.div`
  display: flex;
	color: rgb(120,120,120);
	height: 100%;
	width: 70vw;
	flex-wrap: wrap;
`;

export {
	BuildingImage,
	BuildingAddress,
	BuildingName,
	BuildingDetail,
	BuildingDetailsContainer,
	BuildingInfo,
	ListInfoContainer,
}
